<template>
  <div class="template">
    <div class="search">
      <div class="search-center">
        <div class="search-item">
          <Input clearable
                 v-model="search.title"
                 placeholder="名称"
                 style="width: 150px;"
                 @on-enter="searchFn"/>
        </div>
        <div class="search-item">
          <Input clearable
                 v-model="search.name"
                 placeholder="联系人"
                 style="width: 150px;"
                 @on-enter="searchFn"/>
        </div>
        <div class="search-item">
          <Input clearable
                 v-model="search.phone"
                 placeholder="联系电话"
                 style="width: 150px;"
                 @on-enter="searchFn"/>
        </div>
        <Button
            style="width: 80px;margin-right: 10px;margin-bottom:5px"
            type="primary"
            icon="ios-search"
            @click="searchFn"
        >查询
        </Button>
      </div>
      <div class="search-center">
        <Button
            style="width: 80px;"
            type="primary"
            @click="addFactory"
        >新增工厂
        </Button>
      </div>
    </div>
    <div class="table">
      <Table
          ref="selection"
          @on-select="selectSupplier"
          @on-select-cancel="selectSupplier"
          @on-select-all="selectSupplier"
          @on-select-all-cancel="selectSupplier"
          :columns="diyData.columns"
          :data="apiData.tableList"
          @on-drag-drop="changeTableSort"
      >
        <template slot="footer">
          <div class="pagination">
            <Button style="margin-right: 10px;" @click="handleSelectAll(true)">全选</Button>
          </div>
          <Page
              :total="apiData.total"
              show-total
              :page-size="search.pageSize"
              :current="search.pageNo"
              @on-change="pageChange"
              @on-page-size-change="pageSizeChange"
              class-name="footer-page"
              show-elevator
              show-sizer
              placement="top"
          ></Page>
        </template>
      </Table>
    </div>

    <!--编辑抽屉-->
    <Drawer title="工厂编辑" width="400" :closable="false" v-model="diyDom.showModal">
      <Form
          ref="editForm"
          :model="form"
          :label-width="100"
      >
        <FormItem label="名称" prop="title">
          <Input
              placeholder="请输入名称"
              v-model="form.title"
              style="max-width:300px;width:100%"
          />
        </FormItem>
        <FormItem label="联系人" prop="name">
          <Input
              placeholder="请输联系人"
              v-model="form.name"
              style="max-width:300px;width:100%"
          />
        </FormItem>
        <FormItem label="联系电话" prop="phone">
          <Input
              placeholder="请输电话"
              v-model="form.phone"
              style="max-width:300px;width:100%"
          />
        </FormItem>
        <FormItem label="地址" prop="address">
          <Input
              placeholder="请输地址"
              v-model="form.address"
              style="max-width:300px;width:100%"
          />
        </FormItem>
        <FormItem label="发货地址" prop="sendAddress">
          <Input
              placeholder="请输发货地址"
              v-model="form.sendAddress"
              style="max-width:300px;width:100%"
          />
        </FormItem>
      </Form>
      <div>
        <Button style="width: 90px" @click="closeModal()">返回</Button>
        <Button type="primary" @click="submitSave()" style="width: 90px; margin-left: 20px">提交</Button>
      </div>
    </Drawer>
  </div>
</template>

<script>
import Treeselect from '@riophae/vue-treeselect'
import '@riophae/vue-treeselect/dist/vue-treeselect.css'
import {apiAdFactoryDelete, apiAdFactoryInfo, apiAdFactoryList, apiAdFactorySave} from "@/api/ad-factory";
import {apiProducttempInfo} from "@/api/template-manage";

export default {
  name: 'ad-factory',
  components: {Treeselect},
  data() {
    return {
      search: {
        title: '',
        name: '',
        phone: '',
        pageNo: 1,
        pageSize: 10
      },
      form: {
        id: '',
        title: '',
        name: '',
        phone: '',
        address: '',
        sendAddress: ''
      },
      diyDom: {
        showModal: false,
        type: 1// 1分类,2,标签,3,标记
      },
      diyData: {
        ids: '',
        orderNo: '',
        columns: [
          {
            type: 'selection',
            width: 60,
            align: 'center'
          },
          {
            title: '名称',
            width: '200px',
            key: 'title'
          },
          {
            title: '联系人',
            width: '200px',
            key: 'name'
          },
          {
            title: '联系电话',
            width: '200px',
            key: 'phone'
          },
          {
            title: '店铺地址',
            width: '200px',
            key: 'address'
          },
          {
            title: '创建时间',
            width: '180px',
            key: 'createTime'
          },
          {
            title: ' '
          },
          {
            title: '操作',
            width: '200px',
            fixed: 'right',
            render: (h, params) => {
              return h('div', [
                h('Button', {
                      props: {
                        size: 'small'
                      },
                      style: {
                        marginRight: '10px',
                        fontSize: '14px'
                      },
                      on: {
                        click: () => {
                          this.form.id = params.row.id
                          this.diyDom.showModal = true
                          this.diyData.id = params.row.id
                          apiAdFactoryInfo({
                            id: params.row.id
                          }).then(res => {
                            this.form = {
                              id: res.data.info.id,
                              title: res.data.info.title,
                              name: res.data.info.name,
                              phone: res.data.info.phone,
                              address: res.data.info.address,
                              sendAddress: res.data.info.sendAddress
                            }
                          })
                        }
                      }
                    },
                    '编辑'
                ),
                h('Button', {
                      props: {
                        size: 'small'
                      },
                      style: {
                        marginRight: '10px',
                        fontSize: '14px'
                      },
                      on: {
                        click: () => {
                          this.$Modal.confirm({
                            title: '提示',
                            content: '确认删除？',
                            onOk: () => {
                              apiAdFactoryDelete({
                                ids: params.row.id
                              }).then(res => {
                                this.$Message.success('操作成功')
                                this.getTableList()
                              })
                            }
                          })
                        }
                      }
                    },
                    '删除'
                )
              ])
            }
          }
        ]
      },
      apiData: {
        total: 0,
        infor: null,
        tableList: [],
        productAllTag: [],
        producttypeList: []
      }
    }
  },
  methods: {
    closeModal () {
      this.diyDom.showModal = false
      this.form = {
        id: '',
        title: '',
        name: '',
        phone: '',
        address: '',
        sendAddress: ''
      }
    },
    addFactory(){
      this.form.id = ''
      this.form.title = ''
      this.form.name = ''
      this.form.phone = ''
      this.form.address = ''
      this.form.sendAddress = ''

      this.diyDom.showModal=true
    },
    submitSave(){
       apiAdFactorySave(this.form).then(res => {
          this.$Message.success('操作成功')
      })
    },
    handleSelectAll(status) {
      this.$refs.selection.selectAll(status)
    },
    // 分页
    pageChange(e) {
      this.search.pageNo = e
      this.getTableList()
    },
    pageSizeChange(e) {
      this.search.pageSize = e
      this.search.pageNo = 1
      this.getTableList()
    },
    // 搜索
    searchFn() {
      this.search.pageNo = 1
      this.getTableList()
    },
    getTableList() {
      this.$store.commit('setSpinShow', true)
      var opt = {...this.search}
      apiAdFactoryList(opt).then((res) => {
        const {
          list,
          totalCount
        } = res.data

        this.apiData.tableList = list
        this.apiData.total = totalCount
      }).finally(() => this.$store.commit('setSpinShow', false))
    }

  },
  mounted() {
    var search = sessionStorage.getItem('search') || ''
    if (search) {
      this.search = JSON.parse(search)
      sessionStorage.removeItem('search')
    }
    this.getTableList()
  }
}
</script>

<style scoped lang="less">
.template {
  width: 100%;
  background: #fff;
  padding: 20px;
  box-sizing: border-box;
}

.button-border {
  margin-right: 10px;

}

.tag {
  width: 50px;
  height: 26px;
  opacity: 1;
  border-radius: 5px;
  background: rgba(255, 87, 51, 1);
  text-align: center;
  line-height: 26px;
  font-size: 14px;
  font-weight: 400;
  color: rgba(255, 255, 255, 1);
  margin-left: 10px;
  display: inline-block;
}
</style>
